import { FormBase } from "core/components";

export default class TrackingCaseDocumentUploadFormFields extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "formFields",
                    rules: "required",
                    value: []
                }
            ]
        };
    }
}